import React from "react";

export default function Privacy() {
  return (
    <div className="min-h-screen bg-gradient-to-b from-[#020617] to-[#0f172a] text-white px-6 md:px-16 py-12">
      <div className="max-w-4xl mx-auto space-y-8">
        <h1 className="text-4xl font-bold text-purple-400">Privacy Policy</h1>
        <p className="text-sm text-gray-400">Last updated: October 30, 2025</p>

        <section>
          <h2 className="text-2xl font-semibold mb-3">1. Introduction</h2>
          <p className="text-gray-300">
            Aeronauts ("we", "us") is committed to protecting your privacy. This policy explains how we collect, use,
            and safeguard your personal information.
          </p>
        </section>

        <section>
          <h2 className="text-2xl font-semibold mb-3">2. Data We Collect</h2>
          <ul className="list-disc ml-6 text-gray-300 space-y-2">
            <li>Account information: name, email, user ID, and password (securely hashed).</li>
            <li>Dashboard data you create or upload.</li>
            <li>Usage information such as IP, browser type, and device details.</li>
            <li>Cookies for session management and analytics.</li>
          </ul>
        </section>

        <section>
          <h2 className="text-2xl font-semibold mb-3">3. How We Use Your Data</h2>
          <ul className="list-disc ml-6 text-gray-300 space-y-2">
            <li>To operate and improve our services and dashboard functionality.</li>
            <li>To communicate updates and provide support.</li>
            <li>To ensure security and prevent fraud.</li>
            <li>To create anonymized analytics for internal use.</li>
          </ul>
        </section>

        <section>
          <h2 className="text-2xl font-semibold mb-3">4. Data Security</h2>
          <p className="text-gray-300">
            We use encryption, access controls, and best practices to protect your data. However, no system is entirely
            secure, and users should report any suspicious activity to{" "}
            <a href="mailto:aeronauts.nsut@gmail.com" className="text-purple-400 underline">
              aeronauts.nsut@gmail.com
            </a>
            .
          </p>
        </section>

        <section>
          <h2 className="text-2xl font-semibold mb-3">5. Your Rights</h2>
          <ul className="list-disc ml-6 text-gray-300 space-y-2">
            <li>Access, correct, or delete your data.</li>
            <li>Request data export (portability).</li>
            <li>Withdraw consent where applicable.</li>
          </ul>
          <p className="text-gray-300">
            To exercise your rights, contact us at{" "}
            <a href="mailto:aeronauts.nsut@gmail.com" className="text-purple-400 underline">
              aeronauts.nsut@gmail.com
            </a>
            .
          </p>
        </section>

        <section>
          <h2 className="text-2xl font-semibold mb-3">6. Changes to This Policy</h2>
          <p className="text-gray-300">
            We may update this policy periodically. Continued use of our services after updates implies acceptance of
            the revised terms.
          </p>
        </section>

        <p className="text-sm text-gray-500 pt-6">
          © {new Date().getFullYear()} Aeronauts Drone Society. All rights reserved.
        </p>
      </div>
    </div>
  );
}
